<template>
  <div class="auto-media-step">
    <h3 class="auto-media-step__title">{{ $t('auto.labels.photos') }}</h3>

    <div class="d-flex">
      <div class="auto-media-step__prev-state">
        <div class="auto-media-step__label">
          {{ $t('mechanic.autoLastState') }}
        </div>

        <auto-media-carousel
          :tab.sync="tab"
          :media="lastStateMedia"
          :comments="lastStateComments"
          :additional-photo="lastStateAdditionalPhoto"
          :additional-video="lastStateAdditionalVideo"
          :additional-photo-comment="lastStateAdditionalPhotoComment"
          :additional-video-comment="lastStateAdditionalVideoComment"
          readonly
        />
      </div>

      <div class="auto-media-step__current-state">
        <div class="auto-media-step__label">
          {{ $t('navigation.currentState') }}
        </div>

        <auto-media-carousel
          :tab.sync="tab"
          :media="media"
          :comments="comments"
          :additional-photo="additionalPhoto"
          :additional-video="additionalVideo"
          :additional-photo-comment="additionalPhotoComment"
          :additional-video-comment="additionalVideoComment"
          @update:media="$emit('update:media', $event)"
          @update:comments="$emit('update:comments', $event)"
          @update:additional-photo="$emit('update:additionalPhoto', $event)"
          @update:additional-video="$emit('update:additionalVideo', $event)"
          @update:additional-photo-comment="
            $emit('update:additionalPhotoComment', $event)
          "
          @update:additional-video-comment="
            $emit('update:additionalVideoComment', $event)
          "
        />
      </div>
    </div>
  </div>
</template>

<script>
import AutoMediaCarousel from './AutoMediaCarousel.vue';

export default {
  components: { AutoMediaCarousel },
  props: {
    media: {
      type: Object,
      default: () => ({}),
    },
    comments: {
      type: Object,
      default: () => ({}),
    },
    additionalPhoto: {
      type: Array,
      default: () => ({}),
    },
    additionalVideo: {
      type: Array,
      default: () => ({}),
    },
    additionalPhotoComment: {
      type: String,
      default: '',
    },
    additionalVideoComment: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    tab: 0,
  }),
  computed: {
    lastStateMedia() {
      const media = this.$store.state.mechanic.autoLastState.photo;

      return Object.keys(media).reduce((state, key) => {
        state[key] = {
          key: media[key].key,
          link: media[key].link,
          name: media[key].value,
        };

        return state;
      }, {});
    },
    lastStateComments() {
      const comments = this.$store.state.mechanic.autoLastState.mediaComment;

      return Object.keys(comments).reduce((obj, key) => {
        obj[key] = comments[key].value; // eslint-disable-line

        return obj;
      }, {});
    },
    lastStateAdditionalPhoto() {
      const { additionalPhoto } = this.$store.state.mechanic.autoLastState;

      return additionalPhoto.map((photo) => ({
        key: photo.key,
        link: photo.link,
        name: photo.value,
      }));
    },
    lastStateAdditionalVideo() {
      const { additionalVideo } = this.$store.state.mechanic.autoLastState;

      return additionalVideo.map((video) => ({
        key: video.key,
        link: video.link,
        name: video.value,
      }));
    },
    lastStateAdditionalPhotoComment() {
      const {
        additionalPhotoComment,
      } = this.$store.state.mechanic.autoLastState;

      return additionalPhotoComment.comment
        ? additionalPhotoComment.comment.value
        : '';
    },
    lastStateAdditionalVideoComment() {
      const {
        additionalVideoComment,
      } = this.$store.state.mechanic.autoLastState;

      return additionalVideoComment.comment
        ? additionalVideoComment.comment.value
        : '';
    },
  },
};
</script>

<style lang="scss" scoped>
.auto-media-step {
  &__title {
    font-size: 18px;
    font-weight: 500;
    color: #464646;
    margin-bottom: 30px;
  }

  &__prev-state,
  &__current-state {
    width: 50%;
  }

  &__prev-state {
    padding-right: 30px;
    border-right: 1px dashed #777;
  }

  &__current-state {
    padding-left: 30px;
  }

  &__label {
    margin-bottom: 10px;
    font-weight: 500;
    color: #464646;
    text-align: center;
  }
}
</style>
